import { useEffect, useState } from 'preact/hooks';
import { apiFetch } from '../api/client';

export function AllowanceNotice({ billing, onReview }) {
  const remaining = billing?.remaining_micro;
  const total = billing?.total_allowance_micro;
  // Remaining already excludes pending reservations. This is a notice threshold,
  // not an admission check: platform funding and request size also affect access.
  if (billing?.funded_period !== true || !Number.isSafeInteger(remaining)
    || !Number.isSafeInteger(total) || total <= 0 || remaining > total / 5) return null;

  return <aside role="status" aria-label="AI allowance notice" style={{ padding: '1rem', margin: '0 0 1rem', border: '1px solid var(--sage)', borderRadius: '12px', background: 'var(--cream)', color: 'var(--black)', lineHeight: 1.6 }}>
    <strong>{remaining > 0 ? 'Your AI allowance is running low.' : 'No AI allowance is currently available for new requests.'}</strong>
    <p style={{ margin: '0.5rem 0' }}>Contact support to review your allowance. {billing.automatic_overages === false && 'There are no automatic extra charges.'}</p>
    {onReview && <button type="button" onClick={onReview} style={{ minHeight: '44px', padding: '0.5rem 0.75rem', marginRight: '0.75rem', border: '1px solid var(--sage)', borderRadius: '8px', background: 'white', color: 'var(--black)', cursor: 'pointer' }}>Review allowance</button>}
    <a href="mailto:support@gojonathan.ai?subject=AI%20allowance" style={{ display: 'inline-block', padding: '0.625rem 0', textDecoration: 'underline' }}>Contact support</a>
  </aside>;
}

export function DashboardAllowanceNotice({ onReview, refreshKey }) {
  const [billing, setBilling] = useState(null);
  useEffect(() => {
    let active = true;
    let pending = false;
    const controller = new AbortController();
    async function refresh() {
      if (pending || document.visibilityState === 'hidden') return;
      pending = true;
      setBilling(null);
      try {
        const data = await apiFetch('/v1/owner/billing', { signal: controller.signal });
        if (active) setBilling(data);
      } catch {
        // The billing dialog provides explicit error/retry controls. A failed
        // refresh must not present an old warning as a current balance.
      } finally { pending = false; }
    }
    refresh();
    window.addEventListener('focus', refresh);
    document.addEventListener('visibilitychange', refresh);
    return () => {
      active = false;
      controller.abort();
      window.removeEventListener('focus', refresh);
      document.removeEventListener('visibilitychange', refresh);
    };
  }, [refreshKey]);
  return <AllowanceNotice billing={billing} onReview={onReview} />;
}
